


import React, { useState, useEffect } from "react";
import { Plus, Search, Trash2, Edit2 } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import ApiUrl from "../Environment/ApiUrl";
import { useNavigate } from "react-router-dom";
import excelTemplate from "../../assets/Stock_Excel.xlsx"; // Adjust path to your template file

const StocksTable = () => {
  const [stocksData, setStocksData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [updateModal, setUpdateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadedData, setUploadedData] = useState([]); // For parsed Excel data
  const [privileges, setPrivileges] = useState(null);

  const [updateid, setUpdateid] = useState();

  const navigate = useNavigate();

  const [stockFormData, setStockFormData] = useState({
    hsn_code: "",
    type: "",
    tyre_size: "",
    category: "",
    subcategory: "",
    purchase_rate: "",
    avg_purchase_rate: "",
    mrp: "",
    available_quantity: "",
    total_purchase_quantity: "",
    sold_quantity: "",
    total_purchases: "",
  });

  const [updateData, setUpdateData] = useState({
    hsn_code: "",
    type: "",
    tyre_size: "",
    category: "",
    subcategory: "",
    purchase_rate: "",
    avg_purchase_rate: "",
    mrp: "",
    available_quantity: "",
    total_purchase_quantity: "",
    sold_quantity: "",
    total_purchases: "",
  });

  // Fetch privileges from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  // Fetch stock data on component mount
  useEffect(() => {
    fetchData();
  }, []);

 const fetchData = async () => {
  setLoading(true);
  setError(null);
  try {
    const response = await axios.get(`${ApiUrl}/stock_data.php`);
    if (response.data && response.data.data) {
      // Reverse the data before setting it
      const reversedData = response.data.data.reverse();
      setStocksData(reversedData);
    } else {
      setStocksData([]);
      toast.error("No stock data found.");
    }
  } catch (error) {
    console.error("Error fetching stock data:", error);
    setError("Failed to fetch stock data. Please try again.");
    toast.error("Failed to fetch stock data.");
    setStocksData([]);
  } finally {
    setLoading(false);
  }
};


  const fetchProduct = async (hsnCode) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${ApiUrl}/product_data.php?hsn_code=${hsnCode}`
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setProductData(response.data.data);
        return response.data.data[0];
      } else {
        setProductData([]);
        // toast.warn("No product found for this HSN code.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      setError("Failed to fetch product data. Please try again.");
      toast.error("Failed to fetch product data.");
      setProductData([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handleHsnCodeChange = async (hsnCode, isUpdateForm = false) => {
    if (hsnCode) {
      const product = await fetchProduct(hsnCode);
      if (product) {
        const newData = {
          hsn_code: hsnCode,
          type: product.type || "",
          tyre_size: product.tyre_size || "",
          category: product.Category || "",
          subcategory: product.subcategory || "",
          purchase_rate: isUpdateForm
            ? updateData.purchase_rate
            : stockFormData.purchase_rate,
          avg_purchase_rate: isUpdateForm
            ? updateData.avg_purchase_rate
            : stockFormData.avg_purchase_rate,
          mrp: product.mrp || "",
          available_quantity: isUpdateForm
            ? updateData.available_quantity
            : stockFormData.available_quantity,
          total_purchase_quantity: isUpdateForm
            ? updateData.total_purchase_quantity
            : stockFormData.total_purchase_quantity,
          sold_quantity: isUpdateForm
            ? updateData.sold_quantity
            : stockFormData.sold_quantity,
          total_purchases: isUpdateForm
            ? updateData.total_purchases
            : stockFormData.total_purchases,
        };
        if (isUpdateForm) {
          setUpdateData(newData);
        } else {
          setStockFormData(newData);
        }
      } else {
        const newData = {
          hsn_code: hsnCode,
          type: "",
          tyre_size: "",
          category: "",
          subcategory: "",
          purchase_rate: isUpdateForm
            ? updateData.purchase_rate
            : stockFormData.purchase_rate,
          avg_purchase_rate: isUpdateForm
            ? updateData.avg_purchase_rate
            : stockFormData.avg_purchase_rate,
          mrp: "",
          available_quantity: isUpdateForm
            ? updateData.available_quantity
            : stockFormData.available_quantity,
          total_purchase_quantity: isUpdateForm
            ? updateData.total_purchase_quantity
            : stockFormData.total_purchase_quantity,
          sold_quantity: isUpdateForm
            ? updateData.sold_quantity
            : stockFormData.sold_quantity,
          total_purchases: isUpdateForm
            ? updateData.total_purchases
            : stockFormData.total_purchases,
        };
        if (isUpdateForm) {
          setUpdateData(newData);
        } else {
          setStockFormData(newData);
        }
      }
    } else {
      const newData = {
        hsn_code: "",
        type: "",
        tyre_size: "",
        category: "",
        subcategory: "",
        purchase_rate: isUpdateForm
          ? updateData.purchase_rate
          : stockFormData.purchase_rate,
        avg_purchase_rate: isUpdateForm
          ? updateData.avg_purchase_rate
          : stockFormData.avg_purchase_rate,
        mrp: "",
        available_quantity: isUpdateForm
          ? updateData.available_quantity
          : stockFormData.available_quantity,
        total_purchase_quantity: isUpdateForm
          ? updateData.total_purchase_quantity
          : stockFormData.total_purchase_quantity,
        sold_quantity: isUpdateForm
          ? updateData.sold_quantity
          : stockFormData.sold_quantity,
        total_purchases: isUpdateForm
          ? updateData.total_purchases
          : stockFormData.total_purchases,
      };
      if (isUpdateForm) {
        setUpdateData(newData);
      } else {
        setStockFormData(newData);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!stockFormData.hsn_code) errors.hsn_code = "HSN Code is required";

    if (!stockFormData.tyre_size) errors.tyre_size = "Tyre Size is required";
    if (
      !stockFormData.purchase_rate ||
      isNaN(parseFloat(stockFormData.purchase_rate))
    )
      errors.purchase_rate = "Valid purchase rate is required";
    if (
      !stockFormData.avg_purchase_rate ||
      isNaN(parseFloat(stockFormData.avg_purchase_rate))
    )
      errors.avg_purchase_rate = "Valid average purchase rate is required";
    if (!stockFormData.mrp) errors.mrp = "MRP is required";
    if (
      !stockFormData.available_quantity ||
      isNaN(parseInt(stockFormData.available_quantity))
    )
      errors.available_quantity = "Valid available quantity is required";
    if (
      !stockFormData.total_purchase_quantity ||
      isNaN(parseInt(stockFormData.total_purchase_quantity))
    )
      errors.total_purchase_quantity =
        "Valid total purchase quantity is required";
    if (
      !stockFormData.sold_quantity ||
      isNaN(parseInt(stockFormData.sold_quantity))
    )
      errors.sold_quantity = "Valid sold quantity is required";
    if (
      !stockFormData.total_purchases ||
      isNaN(parseInt(stockFormData.total_purchases))
    )
      errors.total_purchases = "Valid total purchases is required";

    if (Object.keys(errors).length > 0) {
      setError(Object.values(errors).join(", "));
      toast.error(Object.values(errors).join(", "));
      return;
    }

    try {
      const response = await axios.post(
        `${ApiUrl}/stock_data.php`,
        stockFormData
      );
      setStockFormData({
        hsn_code: "",
        type: "",
        tyre_size: "",
        category: "",
        subcategory: "",
        purchase_rate: "",
        avg_purchase_rate: "",
        mrp: "",
        available_quantity: "",
        total_purchase_quantity: "",
        sold_quantity: "",
        total_purchases: "",
      });
      fetchData();
      setShowModal(false);
      toast.success(response.data.message || "Stock item added successfully!");
    } catch (error) {
      console.error("Error adding stock:", error);
      setError("Failed to add stock item. Please try again.");
      toast.error("Failed to add stock item.");
    }
  };

  const handleOpenDeleteModal = (item) => {
    setDeleteItem(item);
    setDeleteShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${ApiUrl}/stock_data.php`, {
        data: {
          hsn_code: deleteItem.hsn_code,
          type: deleteItem.type,
          tyre_size: deleteItem.tyre_size,
          category: deleteItem.category,
          subcategory: deleteItem.subcategory,
        },
      });
      setDeleteShowModal(false);
      fetchData();
      toast.success("Stock item deleted successfully!");
    } catch (error) {
      console.error("Error deleting stock:", error);
      setError("Failed to delete stock item. Please try again.");
      toast.error("Failed to delete stock item.");
    }
  };

  const handleUpdate = (data) => {
    setUpdateModal(true);
    setUpdateData({
      hsn_code: data.hsn_code || "",
      type: data.type || "",
      tyre_size: data.tyre_size || "",
      category: data.category || "",
      subcategory: data.subcategory || "",
      purchase_rate: data.purchase_rate || "",
      avg_purchase_rate: data.avg_purchase_rate || "",
      mrp: data.mrp || "",
      available_quantity: data.available_quantity || "",
      total_purchase_quantity: data.total_purchase_quantity || "",
      sold_quantity: data.sold_quantity || "",
      total_purchases: data.total_purchases || "",
    });
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!updateData.hsn_code) errors.hsn_code = "HSN Code is required";
    // if (!updateData.category) errors.category = "Category is required";
    // if (!updateData.subcategory) errors.subcategory = "Subcategory is required";
    // if (!updateData.type) errors.type = "Type is required";
    if (!updateData.tyre_size) errors.tyre_size = "Tyre Size is required";
    if (
      !updateData.purchase_rate ||
      isNaN(parseFloat(updateData.purchase_rate))
    )
      errors.purchase_rate = "Valid purchase rate is required";
    if (
      !updateData.avg_purchase_rate ||
      isNaN(parseFloat(updateData.avg_purchase_rate))
    )
      errors.avg_purchase_rate = "Valid average purchase rate is required";
    if (!updateData.mrp) errors.mrp = "MRP is required";
    if (
      !updateData.available_quantity ||
      isNaN(parseInt(updateData.available_quantity))
    )
      errors.available_quantity = "Valid available quantity is required";
    if (
      !updateData.total_purchase_quantity ||
      isNaN(parseInt(updateData.total_purchase_quantity))
    )
      errors.total_purchase_quantity =
        "Valid total purchase quantity is required";
    if (!updateData.sold_quantity || isNaN(parseInt(updateData.sold_quantity)))
      errors.sold_quantity = "Valid sold quantity is required";
    if (
      !updateData.total_purchases ||
      isNaN(parseInt(updateData.total_purchases))
    )
      errors.total_purchases = "Valid total purchases is required";

    if (Object.keys(errors).length > 0) {
      setError(Object.values(errors).join(", "));
      toast.error(Object.values(errors).join(", "));
      return;
    }

    const payload = {

      hsn_code: updateData.hsn_code,
      type: updateData.type,
      tyre_size: updateData.tyre_size,
      category: updateData.category,
      subcategory: updateData.subcategory,
      purchase_rate: parseFloat(updateData.purchase_rate) || 0,
      avg_purchase_rate: parseFloat(updateData.avg_purchase_rate) || 0,
      mrp: updateData.mrp || "0",
      available_quantity: parseInt(updateData.available_quantity) || 0,
      total_purchase_quantity:
        parseInt(updateData.total_purchase_quantity) || 0,
      sold_quantity: parseInt(updateData.sold_quantity) || 0,
      total_purchases: parseInt(updateData.total_purchases) || 0,
    };

    try {
      setLoading(true);
      setError(null);
      const response = await axios.put(`${ApiUrl}/stock_data.php`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (!response.data.status) {
        throw new Error(response.data.message || "Failed to update stock");
      }

      const product = await fetchProduct(updateData.hsn_code);
      if (product) {
        if (
          product.type !== updateData.type ||
          product.tyre_size !== updateData.tyre_size ||
          product.category !== updateData.category ||
          product.subcategory !== updateData.subcategory ||
          product.mrp !== updateData.mrp
        ) {
          console.warn(
            "Product data mismatch detected. Consider updating product data."
          );
        }
      }

      setUpdateModal(false);
      fetchData();
      toast.success("Stock updated successfully!");
    } catch (error) {
      console.error("Error updating stock:", error);
      const errorMessage =
        error.response?.status === 404
          ? "Stock item not found"
          : error.message || "Failed to update stock item";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = excelTemplate;
    link.download = "stocks_template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      const headers = parsedData[0];
      const data = parsedData.slice(1).map((row) => {
        let obj = {};
        headers.forEach((header, idx) => {
          obj[header.toLowerCase().replace(/\s/g, "_")] = row[idx];
        });
        return obj;
      });

      setUploadedData(data);
      toast.info("File parsed successfully. Click 'Add from Excel' to upload.");
    };
    reader.readAsBinaryString(file);
  };

  const handleAddFromExcel = async () => {
    if (uploadedData.length === 0) {
      toast.error("No data to upload.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${ApiUrl}/upload_stocks.php`, {
        stocks: uploadedData,
      });
      toast.success("Stocks uploaded successfully!");
      setUploadedData([]);
      fetchData();
    } catch (error) {
      console.error("Error uploading stocks:", error);
      toast.error("Failed to upload stocks.");
    } finally {
      setLoading(false);
    }
  };

  const filteredStocks = stocksData.filter((stock) =>
    Object.values(stock)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredStocks.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentStocks = filteredStocks.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const formatCurrency = (amount) => {
    return `₹${Number(amount).toLocaleString("en-IN") || "0"}`;
  };

  return (
    <div className="bg-white font-sans">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      {error && (
        <div className="alert alert-danger mx-3 mx-md-4 mt-3" role="alert">
          {error}
        </div>
      )}

      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="m-0 fs-5 fw-semibold text-dark">Stocks</h2>
          <div className="d-flex justify-content-end gap-3">
            <button
              className="btn btn-danger d-flex align-items-center gap-2"
              onClick={() => setShowModal(true)}
            >
              <Plus size={18} />
              Add Stock
            </button>
            {privileges === "Admin" && (
              <button
                className="btn btn-danger d-flex align-items-center gap-2"
                onClick={() => navigate("/personal_stock")}
              >
                <Plus size={18} />
                Personal Stocks
              </button>
            )}
            <button
              className="btn btn-primary"
              onClick={handleDownloadTemplate}
            >
              Download Template
            </button>
            <input
              type="file"
              accept=".xlsx"
              onChange={handleFileUpload}
              style={{ marginLeft: "10px", marginTop: '10px' }}
            />
            <button
              className="btn btn-success"
              onClick={handleAddFromExcel}
              disabled={uploadedData.length === 0 || loading}
            >
              {loading ? "Uploading..." : "Add Excel"}
            </button>
          </div>
        </div>
      </div>

      <div className="card mx-3 mx-md-4 border">
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          <div
            className="d-flex align-items-center gap-2"
            style={{ height: "36px", width: "120px" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "28px", width: "14px" }}
            >
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value={filteredStocks.length}>Show All</option>
            </select>
          </div>
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        <div className="card-body p-0">
          {loading ? (
            <div className="text-center p-5">
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-hover mb-0 text-center">
                  <thead>
                    <tr>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        S.No
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        HSN Code
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Category
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Type
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Tyre Size
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        MRP
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Total Qty
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Sold Qty
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Available Qty
                      </th>
                      <th
                        style={{ backgroundColor: "#d3d3d3" }}
                        className="p-3 fw-semibold small"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentStocks.length > 0 ? (
                      currentStocks.map((item, index) => (
                        <tr key={item.id} style={{ fontSize: "14px" }}>
                          <td>{startIndex + index + 1}</td>
                          <td>{item.hsn_code}</td>
                          <td>{item.category}</td>
                          <td>{item.type}</td>
                          <td>{item.tyre_size}</td>
                          <td>{formatCurrency(item.mrp)}</td>
                          <td>{item.total_purchase_quantity}</td>
                          <td>{item.sold_quantity}</td>
                          <td>{item.available_quantity}</td>
                          <td className="small">
                            <div className="d-flex justify-content-center gap-2">
                              {(privileges === "Admin" ) && (

                                  <button
                                    className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                                    onClick={() => handleUpdate(item)}
                                  >
                                    <Edit2 size={16} />
                                  </button>
                                )}

                              {(privileges === "Admin") && (
                                <button
                                  className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                                  onClick={() => handleOpenDeleteModal(item)}
                                >
                                  <Trash2 size={16} />
                                </button>

                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="text-center p-5">
                          {searchTerm
                            ? "No matching records found"
                            : "No stock data available"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {itemsPerPage < filteredStocks.length && (
                <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                    className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === 1
                        ? "bg-light text-muted"
                        : "bg-white text-dark"
                      }`}
                  >
                    <FaChevronLeft size={14} />
                    <span className="ms-1 d-none d-md-inline">Previous</span>
                  </button>
                  <div className="d-flex gap-1">
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNum =
                        totalPages <= 5
                          ? i + 1
                          : currentPage <= 3
                            ? i + 1
                            : currentPage >= totalPages - 2
                              ? totalPages - 4 + i
                              : currentPage - 2 + i;
                      return (
                        <button
                          key={pageNum}
                          onClick={() => setCurrentPage(pageNum)}
                          className={`btn btn-sm ${pageNum === currentPage
                              ? "bg-danger bg-opacity-10 text-danger"
                              : "bg-white text-dark"
                            }`}
                          style={{ width: "32px", height: "32px" }}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                    {totalPages > 5 && currentPage < totalPages - 2 && (
                      <>
                        <span className="px-2 py-1">...</span>
                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className={`btn btn-sm ${totalPages === currentPage
                              ? "bg-danger bg-opacity-10 text-danger"
                              : "bg-white text-dark"
                            }`}
                          style={{ width: "32px", height: "32px" }}
                        >
                          {totalPages}
                        </button>
                      </>
                    )}
                  </div>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === totalPages
                        ? "bg-light text-muted"
                        : "bg-white text-dark"
                      }`}
                  >
                    <span className="ms-1 d-none d-md-inline">Next</span>
                    <FaChevronRight size={14} />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Add Stock Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title m-0 fw-semibold">Add Stock</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setShowModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      HSN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={stockFormData.hsn_code}
                      onChange={(e) => {
                        const hsnCode = e.target.value;
                        setStockFormData({
                          ...stockFormData,
                          hsn_code: hsnCode,
                        });
                        handleHsnCodeChange(hsnCode);
                      }}
                      placeholder="Enter HSN Code"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">Type</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={stockFormData.type}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          type: e.target.value,
                        })
                      }
                      placeholder="Enter Type"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Tyre Size
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={stockFormData.tyre_size}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          tyre_size: e.target.value,
                        })
                      }
                      placeholder="Enter Tyre Size"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Category
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={stockFormData.category}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          category: e.target.value,
                        })
                      }
                      placeholder="Enter Category"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Subcategory
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={stockFormData.subcategory}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          subcategory: e.target.value,
                        })
                      }
                      placeholder="Enter Subcategory"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Purchase Rate
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control form-control-sm"
                      value={stockFormData.purchase_rate}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          purchase_rate: e.target.value,
                        })
                      }
                      placeholder="Enter Purchase Rate"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Average Purchase Rate
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control form-control-sm"
                      value={stockFormData.avg_purchase_rate}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          avg_purchase_rate: e.target.value,
                        })
                      }
                      placeholder="Enter Average Purchase Rate"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">MRP</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={stockFormData.mrp}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          mrp: e.target.value,
                        })
                      }
                      placeholder="Enter MRP"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Available Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={stockFormData.available_quantity}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          available_quantity: e.target.value,
                        })
                      }
                      placeholder="Enter Available Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Total Purchase Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={stockFormData.total_purchase_quantity}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          total_purchase_quantity: e.target.value,
                        })
                      }
                      placeholder="Enter Total Purchase Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Sold Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={stockFormData.sold_quantity}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          sold_quantity: e.target.value,
                        })
                      }
                      placeholder="Enter Sold Quantity"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Total Purchases
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={stockFormData.total_purchases}
                      onChange={(e) =>
                        setStockFormData({
                          ...stockFormData,
                          total_purchases: e.target.value,
                        })
                      }
                      placeholder="Enter Total Purchases"
                      required
                    />
                  </div>
                </div>
                <div className="modal-footer border-top-0 pt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-sm btn-primary">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModal ? "show" : ""}`}
        style={{
          display: deleteShowModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center p-4">
              <div className="mb-3">
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    fill="#FEE2E2"
                    stroke="#DC2626"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 8V12"
                    stroke="#DC2626"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12 16H12.01"
                    stroke="#DC2626"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <h4 className="mb-3">Are you sure?</h4>
              <p className="mb-4">
                This action cannot be undone. The stock item will be permanently
                deleted.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setDeleteShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Update Stock Modal */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{
          display: updateModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-danger text-white">
              <h5 className="modal-title m-0 fw-semibold">Update Stock</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setUpdateModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleUpdateSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      HSN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.hsn_code}
                      onChange={(e) => {
                        const hsnCode = e.target.value;
                        setUpdateData({ ...updateData, hsn_code: hsnCode });
                        handleHsnCodeChange(hsnCode, true);
                      }}
                      placeholder="Enter HSN Code"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">Type</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.type}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, type: e.target.value })
                      }
                      placeholder="Enter Type"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Tyre Size
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.tyre_size}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          tyre_size: e.target.value,
                        })
                      }
                      placeholder="Enter Tyre Size"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Category
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.category}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          category: e.target.value,
                        })
                      }
                      placeholder="Enter Category"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Subcategory
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.subcategory}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          subcategory: e.target.value,
                        })
                      }
                      placeholder="Enter Subcategory"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Purchase Rate
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control form-control-sm"
                      value={updateData.purchase_rate}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          purchase_rate: e.target.value,
                        })
                      }
                      placeholder="Enter Purchase Rate"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Average Purchase Rate
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control form-control-sm"
                      value={updateData.avg_purchase_rate}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          avg_purchase_rate: e.target.value,
                        })
                      }
                      placeholder="Enter Average Purchase Rate"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">MRP</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updateData.mrp}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, mrp: e.target.value })
                      }
                      placeholder="Enter MRP"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Available Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.available_quantity}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          available_quantity: e.target.value,
                        })
                      }
                      placeholder="Enter Available Quantity"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Total Purchase Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.total_purchase_quantity}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          total_purchase_quantity: e.target.value,
                        })
                      }
                      placeholder="Enter Total Purchase Quantity"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Sold Quantity
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.sold_quantity}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          sold_quantity: e.target.value,
                        })
                      }
                      placeholder="Enter Sold Quantity"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Total Purchases
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={updateData.total_purchases}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          total_purchases: e.target.value,
                        })
                      }
                      placeholder="Enter Total Purchases"
                    />
                  </div>
                </div>
                <div className="modal-footer border-top-0 pt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => setUpdateModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-sm btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StocksTable;